<template>
  <div>
    <HeaderSearchLots :img_header="header_image" header="ค้นหาล็อตสินค้า"/>
    <component :is="currentComponent" />
  </div>
</template>

<script>
import HeaderSearchLots from "@/components/admin/search_lot_product/headersearch/HeaderSearchLots";
import HeaderImage from "@/assets/checkk.png";
import Search_ProductLots_new from "../../../components/admin/search_lot_product/Search_ProductLots_new.vue";
import Search_ProductLots_Detail from "../../../components/admin/search_lot_product/Search_ProductLots_Detail.vue";

export default {
  name: "SearchProductLots",
  components: {
    Search_ProductLots_new,
    Search_ProductLots_Detail,
    HeaderSearchLots
  },
  data() {
    return {
      header_image: HeaderImage
    }
  },
  computed: {
    currentComponent() {
      // ถ้ามี view=detail แสดงหน้ารายละเอียด
      if (this.$route.query.view === 'detail') {
        return 'Search_ProductLots_Detail'
      }
      // ไม่งั้นแสดงหน้าค้นหา
      return 'Search_ProductLots_new'
    }
  }
}
</script>

<style scoped>

</style>